<template>
  <div>
    <Header />
    <!-- banner开始 -->
    <div class="pc-banner">
      <el-carousel :interval="10000" indicator-position="outside">
        <el-carousel-item v-for="(img, index) in Path" :key="index">
          <div class="carousel-item">
            <img :src="img.resUrl" @click="getJumdetails(index)" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- banner结束 -->
    <div class="pc-data">
      <div class="pc-data-top">
        <img :class="{ animation: date_animation }" width="282px" height="75px" src="@/assets/images/yc_rl.png" />
        <img :class="{ animation: date_animation }" width="145px" height="145px" src="@/assets/images/ewm.png" />
      </div>
      <div class="pc-data-body">
        <div class="calendar-container">
          <div class="date_all">
            <div class="all_month">{{ month }}</div>
            <div class="all_line">
              <img src="@/assets/images/li.png" style="width: 16px;height: 26px;" />
            </div>
            <div class="all_l">
              <div class="all_day">{{ Days }}</div>
              <div class="all_year">{{ year }}</div>
            </div>
          </div>
          <div class="header">
            <div class="carousel-item" @click="prevMonth" style="cursor: pointer;">
              <img src="@/assets/images/l.png" />
            </div>
            <span class="month-year">{{ year }}年{{ month }}月</span>
            <div class="carousel-item" @click="nextMonth" style="cursor: pointer;">
              <img src="@/assets/images/r.png" />
            </div>
          </div>
          <table class="calendar-table">
            <thead>
              <tr>
                <th>S</th>
                <th>M</th>
                <th>T</th>
                <th>W</th>
                <th>T</th>
                <th>F</th>
                <th>S</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(week, index) in calendar" :key="index">
                <td v-for="(day, dayIndex) in week" :key="dayIndex" :class="{
          'selected-day':
            day === selectedDay || (!selectedDay && day === Days),
          'empty-day': day === 0,
          'has-event': hasEvent(day)
        }" @click="selectDay(day)">
                  {{ day }}
                  <span v-if="hasEvent(day)" class="event-dot"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div :class="{ animation: date_animation }" class="pc-data-body-right">
          <div class="pc-data-body-top" v-if="visibleItems.length > 0">
            <div class="pc-data-item" v-for="(item, index) in visibleItems" :key="index" @click="getListdetails(index)">
              <img :src="item.pcCoverImgZh" class="zoom" />
              <div class="pc-data-name">
                <span>{{ item.name }}</span>
                <!-- <p>2024-09-12 19:00</p> -->
              </div>
            </div>
          </div>
          <div v-if="visibleItems.length == 0" class="datali">
            <img src="@/assets/images/zanwu.png" style="margin-top: 50px;" />
            <div class="moredata">暂无演出，敬请期待。</div>
          </div>
          <div class="pc-data-body-foot" v-if="visibleItems.length > 0">
            <img width="40px" height="35px" style="margin-right: 80px;cursor: pointer;" @click="prevItems"
              src="@/assets/images/l.png" v-if="showleft" />
            <img width="20px" height="20px" style="margin-right: 80px;cursor: pointer;" src="@/assets/images/left.png"
              v-else />
            <img width="40px" height="35px" v-if="showrigth" style="cursor: pointer;" @click="nextItems"
              src="@/assets/images/r.png" />
            <img width="40px" height="35px" v-else style="cursor: pointer;" src="@/assets/images/rr.png" />
          </div>
        </div>


      </div>
    </div>
    <div class="pc-data-body-yc">
      <div :class="{ animation: yc_animation }" class="pc-data-common-title">
        <img width="411px" height="77px" src="@/assets/images/title2.png" />
        <div class="pc-data-common-title-right" @click="
          goTo('/performs', '自制电视剧',)
          ">
          MORE
          <img src="@/assets/images/more.png" />
        </div>
      </div>
      <div :class="{ animation: yc_animation }" class="pc-data-yc-list">
        <div class="pc-yc-list-item" v-for="(item, index) in purchaselist">
          <img :src="item.pcCoverImgZh" class="zoom" />
          <span>{{ item.name }}</span>
          <a @click="getJum(index)">
            演出讯息
            <img src="@/assets/images/more1.png" />
          </a>
        </div>
      </div>
    </div>
    <div class="pc-data-body-mt">
      <div :class="{ animation: mt_animation }" class="pc-data-common-title">
        <img width="411px" height="77px" src="@/assets/images/title1.png" />
        <div class="pc-data-common-title-right" @click="goTo('/newIndex')">
          MORE
          <img src="@/assets/images/more.png" />
        </div>
      </div>
      <div :class="{ animation: mt_animation }" class="pc-data-mt-list">
        <div v-for="(item, index) in mediaList" :key="index" class="media_list">
          <div class="media" @click="getJumdetails(index)">
            <div class="date_all">
              <div class="all_month" style="color: #fff;">{{ item.month }}</div>
              <div class="all_line">
                <img src="@/assets/images/li.png" style="width: 16px;height: 26px;" />
              </div>
              <div class="all_l">
                <div class="all_day" style="color: #fff;">{{ item.day }}</div>
                <div class="all_year" style="color: #fff;">{{ item.year }}</div>
              </div>
            </div>
            <div class="media_title">{{ item.title }}</div>
            <div class="media_span">{{ item.adRemark }}</div>
            <div class="me-right">
              <div>MORE</div>
              <div>
                <img src="@/assets/images/more.png" style="width: 24px;height: 24px;margin-bottom: 0px;" />
              </div>
            </div>
          </div>
          <div class="media_path">
            <img :src="item.headerImg" class="zoom" />
          </div>
        </div>
      </div>
    </div>
    <Footer style="float: left;"/>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import {
  getCalendar,
  getShowList,
  getMediaReportList,
  getShowDateList,
  getbaList
} from "../network/home.js";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  data() {
    const today = new Date();
    return {
      date_animation: false,
      yc_animation: false,
      mt_animation: false,
      foot_animation: false,

      year: today.getFullYear(),
      month: today.getMonth() + 1,
      Days: today.getDate(),

      selectedDay: null,
      specialDays: {},
      mediaList: [],
      activeMenu: "",
      page: 1,
      limit: 15,
      list: [], // 所有项目数据
      currentIndex: 0, // 当前显示的项目索引
      date_animation: false, // 控制动画的布尔值
      itemsPerPage: 2, // 每页显示的项目数
      totalPages: 0, // 总页数
      purchaselist: [],
      showleft: true,
      showrigth: true,
      visibleItems: [], // 当前显示的内容项
      y: '',
      m: '',
      d: '',
      Itemslist: [],
      Path: [],
    };
  },
  components: {
    Header,
    Footer
  },
  computed: {
    calendar() {
      const firstDay = new Date(this.year, this.month - 1, 1);
      const lastDay = new Date(this.year, this.month, 0);
      const daysInMonth = lastDay.getDate();
      const startDayOfWeek = firstDay.getDay();
      let calendar = [];
      let currentDay = 1;
      let totalWeeks = Math.ceil((daysInMonth + startDayOfWeek) / 7);
      for (let i = 0; i < totalWeeks; i++) {
        let week = [];
        for (let j = 0; j < 7; j++) {
          const dayIndex = i * 7 + j;
          if (i === 0 && j < startDayOfWeek) {
            week.push(0);
          } else if (currentDay > daysInMonth) {
            week.push(0);
          } else {
            week.push(currentDay);
            currentDay++;
          }
        }
        calendar.push(week);
      }
      return calendar;
    },


    // 计算是否可以切换到上一组
    canPrev() {
      return this.currentIndex > 0;
    },
    // 计算是否可以切换到下一组
    canNext() {
      return this.currentIndex + 2 < this.Itemslist.length;
    }
  },
  created() {
    localStorage.setItem("newIndex", 1);
    window.onscroll = () => {
      this.scroll();
    };
  },
  mounted() {
    const today = new Date();
    this.y = today.getFullYear()
    let m = today.getMonth() + 1
    let d = today.getDate()
    this.m = m.toString().padStart(2, '0'); // 确保月份是两位数
    this.d = d.toString().padStart(2, '0');
    if (sessionStorage.getItem("classIndx")) {
      this.activeMenu = sessionStorage.getItem("classIndx");
    }
    this.getadList()
    this.getList();
    this.getprogram();
    this.getpurchase();
    this.getShowDate()
    if (this.currentIndex === 0) {
      this.showleft = false
    }
  },
  methods: {

    // 获取轮播图列表
    async getadList() {
      try {
        let res = await getbaList();
        this.Path = res.data;
        return res;
      } catch (e) {
        console.log(e);
      }
    },
    goTo(url, index, id) {
      this.activeMenu = url;
      sessionStorage.setItem("classIndx", this.activeMenu);
      this.$router.push({ path: url, query: { indexs: index, id: id } });
    },
    // 获取日历
    async getList() {
      let token = localStorage.getItem("token");
      try {
        let res = await getCalendar({ online: true }, token);
        const specialDays = {};
        let datesArray = res.data;
        datesArray.forEach(date => {
          specialDays[date] = ".";
        });
        this.specialDays = specialDays;
      } catch (e) { }
    },
    // 获取节目
    async getprogram() {
      try {
        let res = await getShowList({ limit: this.limit, page: this.page });
        this.list = res.data;
        this.purchaselist = res.data.slice(0, 4);
        this.totalPages = res.totalPage;
        this.updateVisibleItems();
      } catch (e) { }
    },
    // 获取有场次的日期列表
    async getShowDate() {
      let date = this.y + '-' + this.m + '-' + this.d
      let token = localStorage.getItem("token");
      try {
        let res = await getShowDateList({ online: 0, showDate: date }, token);
        this.Itemslist = res.data
        this.visibleItems = this.Itemslist.slice(this.currentIndex, this.currentIndex + 2);

      } catch (e) { }
    },
    // 获取媒体报道
    async getpurchase() {
      try {
        let res = await getMediaReportList();
        res.data.map(time => {
          time.year = time.createTime.substring(0, 4);
          (time.month = time.createTime.substring(5, 7)),
            (time.day = time.createTime.substring(8, 10));
        });
        this.mediaList = res.data;
      } catch (e) { }
    },
    // 跳转到详情页
    getListdetails(index) {
      let id = this.visibleItems[index].id;
      this.$router.push({ path: "/details", query: { id: id } });
    },
    getJum(index) {
      let id = this.purchaselist[index].id;
      this.$router.push({ path: "/details", query: { id: id } });
    },
    getJumdetails(index) {
      let id = this.mediaList[index].id;
      this.$router.push({ path: "/newDetails", query: { id: id } });
    },
    //滚动页面获取高度
    scroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let scrollPercent = scrollTop / (scrollHeight - clientHeight);
      let scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded >= 4) {
        this.date_animation = true;
      }
      if (scrollPercentRounded >= 29) {
        this.yc_animation = true;
      }
      if (scrollPercentRounded >= 51) {
        this.mt_animation = true;
      }
      if (scrollPercentRounded >= 93) {
        this.foot_animation = true;
      }
    },
    isSpecialDay(day) {
      const dateStr = `${this.year}-${this.month}-${String(day).padStart(
        2,
        "0"
      )}`;
      return this.specialDays[dateStr] !== undefined;
    },
    hasEvent(day) {
      const dateStr = `${this.year}-${this.month}-${String(day).padStart(
        2,
        "0"
      )}`;
      return this.specialDays[dateStr] === ".";
    },
    selectDay(day) {
      this.d = day.toString().padStart(2, '0')
      if (day !== 0) {
        this.selectedDay = day;
      }
      // this.getprogram();
      this.getShowDate()
      setTimeout(() => {
      }, 300)
    },
    prevMonth() {
      const currentMonth = parseInt(this.month, 10);
      if (currentMonth === 1) {
        this.year--;
        this.month = "12";
        this.y = this.year
        this.m = this.month
        setTimeout(() => {
          this.getShowDate()
        }, 300)
      } else {
        this.month = String(currentMonth - 1).padStart(2, "0");
        this.y = this.year
        this.m = this.month
        setTimeout(() => {
          this.getShowDate()
        }, 300)
      }
    },
    nextMonth() {
      const currentMonth = parseInt(this.month, 10);
      if (currentMonth === 12) {
        this.year++;
        this.month = "01";
        this.y = this.year
        this.m = this.month
        setTimeout(() => {
          this.getShowDate()
        }, 300)
      } else {
        this.month = String(currentMonth + 1).padStart(2, "0");
        this.y = this.year
        this.m = this.month
        setTimeout(() => {
          this.getShowDate()
        }, 300)
      }
    },
    updateVisibleItems() {
      this.visibleItems = this.Itemslist.slice(this.currentIndex, this.currentIndex + 2);
      if (this.currentIndex === 0) {
        this.showleft = false
      }
    },
    // 切换到上一组
    prevItems() {
      if (this.canPrev) {
        this.currentIndex -= 2;
        this.updateVisibleItems();
        this.showrigth = true
      } else {
        this.showleft = false;
        this.showrigth = true
      }
    },
    // 切换到下一组
    nextItems() {
      if (this.canNext) {
        this.currentIndex += 2;
        this.updateVisibleItems();
        this.showleft = true
      } else {
        this.showleft = true
        this.showrigth = false
      }
    },
  }
};
</script>

<style scoped>
body {
  font-family: OPPOSans;
}

/* 定义淡入动画 */
/* @keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
} */
.animation {
  /* opacity: 0;
  transform: translateY(100%);
  animation: fadeIn 1s forwards; */
  transition: transform 0.5s ease-in-out;
}

.pc-banner {
  width: 100%;
  height: 900px;
  float: left;
}

.pc-banner>>>.el-carousel--horizontal {
  height: 900px;
}

.pc-banner>>>.el-carousel__container {
  height: 900px;
}

.pc-banner>>>.carousel-item {
  height: 900px;
}

.pc-banner>>>.el-carousel__indicators--outside {
  position: absolute !important;
}

.pc-banner>>>.el-carousel__indicator--horizontal {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  padding: unset;
  margin-right: 15px;
}

.pc-banner>>>.el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.pc-banner>>>.el-carousel__arrow {
  width: 45px !important;
  height: 45px !important;
  font-size: 20px !important;
}

.pc-banner img {
  width: 100%;
  height: 900px;
  object-fit: cover;
}

.pc-data {
  width: 100%;
  height: calc(100vh - 140px);
  float: left;
  background: url("../assets/images/yc-bj.png") no-repeat;
  background-size: 100% 100%;
}

.pc-data-top {
  width: 100%;
  max-width: 1440px;
  height: 145px;
  margin: 80px auto 0;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}
.pc-data-body {
  width: 100%;
  max-width: 1440px;
  height: 448px;
  margin: 70px auto 0;
  box-sizing: border-box;
  display: flex;
  padding: 0 20px;
}

.pc-data-body-right {
  width: 969px;
  height: 484px;
  background: #ffffff;
  box-shadow: 0 0 43px 0 rgba(0, 0, 0, 0.1);
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #ffffff;
  margin-left: 76px;
  padding: 30px;
  box-sizing: border-box;
}

.pc-data-body-top {
  width: 100%;
  height: 375px;
  float: left;
  margin-bottom: 26px;
  display: flex;
  overflow: hidden;
}

.pc-data-body-foot {
  width: 100%;
  height: 25px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pc-data-item {
  width: 440px;
  height: 375px;
  margin-right: 30px;
  cursor: pointer;
}

.pc-data-item img {
  width: 100%;
  height: 294px;
  object-fit: cover;
  float: left;
  border-radius: 20px;
}

.zoom {
  transition: transform 0.3s ease;
}

.zoom:hover {
  transform: scale(1.1);
  /* 鼠标悬停时放大到1.1倍 */
}

.pc-data-name {
  width: 100%;
  height: auto;
  float: left;
  margin-top: 20px;
}

.pc-data-name span {
  font-weight: 500;
  font-size: 25px;
  color: #231815;
}

.pc-data-name p {
  font-weight: 400;
  font-size: 16px;
  color: #7a6d6a;
  margin: unset;
  margin-top: 8px !important;
}

.pc-data-item:last-child {
  margin-right: unset !important;
}

.pc-data-body-yc {
  width: 100%;
  height: 649px;
  float: left;
  background: #000;
  /* padding: 0 260px; */
  box-sizing: border-box;
}

.pc-data-common-title-right {
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pc-data-body-mt {
  width: 100%;
  min-height: 1335px;
  float: left;
  background: #000;
  /* padding: 0 260px; */
  box-sizing: border-box;
}


.weibo-icon,
.wechat-icon {
  position: relative;
}


.wechat-icon:hover .qrcode-b {
  display: block;
}


.weibo-icon:hover .qrcode-b {
  display: block;
}


.homepic {
  margin-right: 5px;
  margin-top: -5px;
}

.pc-data-common-title {
  width: 100%;
  max-width: 1440px;
  height: 77px;
  margin: 80px auto 89px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}

.pc-data-yc-list {
  width: 100%;
  max-width: 1440px;
  height: 434px;
  display: flex;
  gap: 20px;
  margin: 89px auto 0;
  padding: 0 20px;
  box-sizing: border-box;
}

.pc-yc-list-item {
  flex: 1;
  overflow: hidden;
  height: 434px;
  object-fit: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pc-yc-list-item img {
  width: 100%;
  height: 220px;
  border-radius: 20px;
  object-fit: cover;
  /* cursor: pointer; */
}

.pc-yc-list-item span {
  width: 100%;
  height: 26px;
  margin-top: 15px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  display: block;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 溢出隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.pc-yc-list-item a {
  cursor: pointer;
  width: 115px;
  height: 35px;
  background: #e4bf92;
  border-radius: 62px 62px 62px 62px;
  margin-top: 15px;
  display: flex;
  font-weight: 400;
  font-size: 14px;
  color: #000;
  line-height: 35px;
  justify-content: center;
  align-items: center;
}

.pc-yc-list-item a:hover {
  background-color: #af916c;
}

.pc-yc-list-item>a>img {
  width: 24px;
  height: 24px;
}

.pc-yc-list-item:last-child {
  margin-right: unset !important;
}

.pc-data-mt-list {
  width: 100%;
  max-width: 1440px;
  margin: 89px auto 0;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  box-sizing: border-box;
}

.pc-data-mt-list img {
  width: 100%;
  height: auto;
  object-fit: cover;
  /* margin-bottom: 50px; */
}

/* 日历样式 */
.calendar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin: 20px; */
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.month-year {
  font-size: 18px;
  font-weight: bold;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.calendar-table th,
.calendar-table td {
  text-align: center;
  padding: 15px;
  cursor: pointer;
  font-weight: 800;
  font-size: 16px;
}

.calendar-table th {
  font-weight: 400;
  font-size: 18px;
}

.selected-day {
  color: #fff;
  background-color: #231815;
  border-radius: 50%;
}

.empty-day {
  background-color: #fdfdfc;
  color: #fdfdfc;
}

.date_all {
  display: flex;
  text-align: center;
  padding-bottom: 45px;
  align-items: center;
}

.all_day {
  font-weight: 800;
  font-size: 30px;
  color: #231815;
}

.all_year {
  font-family: OPPOSans, OPPOSans;
  font-weight: 500;
  font-size: 20px;
  color: #231815;
}

.all_month {
  font-weight: 800;
  font-size: 80px;
  color: #231815;
}

.all_line {
  margin-right: 7px;
  margin-left: 10px;
}

.event-dot {
  display: block;
  width: 5px;
  height: 5px;
  background-color: #ff7a00;
  border-radius: 50%;
  margin: 0 auto;
  /* margin-top: 5px; */
}

/* 媒体报道 */
.pc-data-body-mt {
  width: 100%;
}

.media_list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  cursor: pointer;
}

.media_path img {
  width: 647px;
  height: 402px;
  object-fit: cover;
}

.media {
  width: 40%;
}

.pc-data-common-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 89px;
}

.pc-data-common-title-right {
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pc-data-common-title-right img {
  width: 24px;
  height: 24px;
}

.path_l {
  width: 411px;
  height: 77px;
}

.media_title {
  font-weight: bold;
  font-size: 25px;
  color: #ffffff;
  line-height: 40px;
  margin-bottom: 32px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* 限制在两行内 */
  overflow: hidden;
  text-overflow: ellipsis;
  box-orient: vertical;
  line-height: 1.5;
  /* 根据设计需要调整行高 */
  max-height: 3em;
}

.media_span {
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 28px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* 限制在两行内 */
  overflow: hidden;
  text-overflow: ellipsis;
  box-orient: vertical;
  line-height: 1.5;
  /* 根据设计需要调整行高 */
  max-height: 3em;
  opacity: 0.7;
}

.me-right {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  margin-top: 30px;
  cursor: pointer;
  opacity: 0.7;
  height: 31px;
}

.moredata {
  font-family: OPPOSans, OPPOSans;
  font-weight: 500;
  color: #231815;
  font-size: 20px;
  /* margin-top: 20px; */
}

.datali {
  text-align: center;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue